import { render, staticRenderFns } from "./publicTop.vue?vue&type=template&id=ddc52004&scoped=true"
import script from "./publicTop.vue?vue&type=script&lang=js"
export * from "./publicTop.vue?vue&type=script&lang=js"
import style0 from "./publicTop.vue?vue&type=style&index=0&id=ddc52004&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc52004",
  null
  
)

export default component.exports